import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from 'components/Accordion';
import { Grid } from 'components/layout';
import { AvailableTabs } from 'constants/SidebarTabs';
import useLogPostHogPageView from 'hooks/useLogPostHogPageView';
import { NormalizedLoad } from 'types/Load';
import { PendingCarrierEmails } from 'types/PendingOutboxEmail';
import Pageview from 'types/enums/Pageview';

import CarrierEmails from './Outbox/CarrierEmails';

interface OutboxTabProps {
  normalizedLoad: NormalizedLoad;
  carrierEmails: PendingCarrierEmails;
  setTab: React.Dispatch<React.SetStateAction<AvailableTabs>>;
}

export default function OutboxTab(props: OutboxTabProps) {
  useLogPostHogPageView(Pageview.OutboxEmails, {
    service_id: props.normalizedLoad.serviceID,
    load_id: props.normalizedLoad.ID,
    freightTrackingID: props.normalizedLoad.freightTrackingID,
  });

  return (
    <div className='pb-20'>
      <Accordion
        type='single'
        defaultValue='carrierEmails'
        collapsible
        className='w-full'
      >
        <AccordionItem value='carrierEmails'>
          <AccordionTrigger className='px-4'>Carrier Emails</AccordionTrigger>
          <AccordionContent className='w-full mx-0'>
            <Grid cols='1' gap='sm'>
              <CarrierEmails {...props} />
            </Grid>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
}
